// Services
import { getCurrentUserToken, getHasRememberedBetterAuthSessionUser } from '../../../auth/authService';

// A request authenticates via the Better Auth session cookie (rather than the legacy JWT header) when
// it explicitly skips the auth header, or when there's no legacy token but this client holds a
// remembered Better Auth session. In Capacitor the app runs cross-origin (capacitor://... → the API),
// so the cookie is only attached when `withCredentials` is set. Scope it to these cookie requests so
// legacy JWT traffic and anonymous requests are untouched — avoiding credentialed-CORS regressions on
// routes that respond with `Access-Control-Allow-Origin: *` (e.g. the media server).
const usesBetterAuthSessionCookie = (config) =>
    !!config.skipAuthHeader || (!getCurrentUserToken() && getHasRememberedBetterAuthSessionUser());

export default (config) => {
    config.headers = config.headers || {};

    if (config.skipAuthHeader) {
        if (typeof config.headers.delete === 'function') {
            config.headers.delete('Authorization');
            config.headers.delete('authorization');
        } else {
            delete config.headers.Authorization;
            delete config.headers.authorization;
        }
    } else {
        const token = getCurrentUserToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    // Only default withCredentials for cookie-authenticated requests; never override an explicit value.
    if (config.withCredentials === undefined && usesBetterAuthSessionCookie(config)) {
        config.withCredentials = true;
    }

    return config;
};
